import React from 'react'

import { Typography } from '@smooth-ui/core-em'
import { Box, Space, Button } from 'UILibrary'
import queryString from 'query-string'
import { resendActivationEmail } from 'services/api'
import PropTypes from 'prop-types'
import { css } from 'react-emotion'
import Loader from '../../../components/Loader'

const verifyAccountDiv = css({
  padding: '15px',
  display: 'block',
})
const VerifyAccount = ({ location, history, showFlashMessage, isLoadingStatus, isLoading }) => {
  const email = queryString.parse(location.search).email

  const handleResendActivationEmail = async () => {
    isLoadingStatus(true)
    const { errors } = await resendActivationEmail(email)
    errors && isLoadingStatus(false)
    if (0 < errors.length) {
      isLoadingStatus(false)
      showFlashMessage(true, `${errors.join(';')}`)
    }
  }

  return (
    <span className={verifyAccountDiv}>
      <Typography variant="h3">Please verify your account</Typography>
      <Space size="xl" />
      <Box>
        <Typography>
          In order to log in, you must verify your account. An email has been sent to <Typography fontWeight="500">{email}</Typography> with a link to verify
          your account.
        </Typography>
      </Box>
      <Space size="l" />
      <Box>
        <Typography>If you have not received the email after a few minutes please check your span folder or re-send the verification email</Typography>
      </Box>
      <Space size="xl" />
      <Button form success onClick={() => history.push({ pathname: '/', search: `?signin=true` })}>
        BACK TO LOGIN
      </Button>
      <Space size="s" />
      <Button form back onClick={handleResendActivationEmail}>
        {isLoading ? <Loader /> : ' RE-SEND ACTIVATION EMAIL'}
      </Button>
    </span>
  )
}

VerifyAccount.propTypes = {
  showFlashMessage: PropTypes.func.isRequired,
}

export default VerifyAccount



// WEBPACK FOOTER //
// ./src/features/authentication/components/VerifyAccount.js